export default __webpack_public_path__ + "static/media/bg.e665e6d5.png";